import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Moment } from 'moment/moment';
import { DateTimezoneService } from '../shared/date-timezone.service';
import { DateService } from '../../shared/date.service';

@Component({
  selector: 'app-timezone-date',
  templateUrl: './timezone-date.component.html',
  styleUrls: ['./timezone-date.component.scss']
})
export class TimezoneDateComponent implements OnInit {

  @Input()
  time: Moment;

  @Input()
  displayBothDates: boolean;

  @Input()
  alignRight = false;

  @Input()
  displayLogo = true;

  @Input()
  dateFormat: string;

  tripTimezoneTime: String;
  defaultTimezoneTime: String;

  constructor(public timeZoneService: DateTimezoneService,
              private dateService: DateService) { }

  ngOnInit() {
    this.timeZoneService.timezoneChange.subscribe(() => this.computeCurrentTimeZoneDate());
    this.dateService.localeChanged.subscribe(() => this.computeCurrentTimeZoneDate());
  }

  private computeCurrentTimeZoneDate(): string | null {
    if (this.time == null) {
      return null;
    }
    this.tripTimezoneTime = this.dateService.formatWithLocale(this.timeZoneService.getTripTime(this.time), this.dateFormat);
    this.defaultTimezoneTime = this.dateService.formatWithLocale(this.timeZoneService.getDefaultTime(this.time), this.dateFormat);
  }
}
